"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BLOB_TYPES = void 0;
var BLOB_TYPES = ['text', 'dataURL', 'arrayBuffer', 'binaryString'];
exports.BLOB_TYPES = BLOB_TYPES;